
export default {
  name: 'EmptyLayout',
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageNotFound: '404 Not Found',
      otherError: 'An error occurred',
      isRedirecting: false,
    }
  },
   mounted() {
    // Auto redirect về trang chủ khi gặp lỗi 404
    if (this.error && this.error.statusCode === 404) {
      this.isRedirecting = true
      
      // Delay 2 giây trước khi redirect để user có thể thấy thông báo
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    }
  },
  head() {
    const title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError
    return {
      title,
    }
  },
}
